import PropTypes from 'prop-types';

import { simpleRichTextType } from 'humanity/components/simpleRichText/simpleRichText.types';
import { contentfulMediaType } from 'types/common/contentfulMedia.types';

export const lcMastheadProps = {
  background: PropTypes.oneOf(['teal10', 'brightBlue10']),
  imagesCollection: PropTypes.shape({
    items: PropTypes.arrayOf(contentfulMediaType),
  }),
  heading: PropTypes.string.isRequired,
  headingHighlight: PropTypes.string.isRequired,
  paragraph: simpleRichTextType,
  searchInput: PropTypes.string,
};

export const lcMastheadType = PropTypes.shape({});
